import { config } from './config';
import axios from "axios";

export const administrationAvailableSubdomainLocalesService = {
    getAll,
    config
};


export function getAll(filters) {

    let axiosConfig = {};

    axiosConfig['params'] = filters || {};
    axiosConfig['params']['is_available'] = 'True'

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}/api/administration/available-subdomain-locales/`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}